import { URLs } from '../config'
import http from './http'
import { objectToFormdata } from './common'

export const calendar = {
    get: {
        // @Url /v1/calendars/{cbidx}/{luidx}
        calendars: async (params) =>  {
            return await http.get(
                `${URLs.calendars}/${params.cbidx}/${params.luidx}`,
                {
                    params: params
                }
            )
        },
        // @Url /v1/calendars/management/{cbidx}
        management: async (params) => {
            return await http.get(
                `${URLs.calendars}/management/${params.cbidx}`,
                {
                    params: params
                }
            )
        },
        // @Url v1/calendars/staff/{cbidx}
        staff: async (params) => {
            return await http.get(
                `${URLs.calendars}/staff/${params.cbidx}`,
                {
                    params: params
                }
            )
        },
        // @Url v1/calendars/recipient/{cbidx}
        recipient: async (params) => {
            return await http.get(
                `${URLs.calendars}/recipient/${params.cbidx}`,
                {
                    params: params
                }
            )
        },
    },
    post: {
        // @Url /v1/calendars/personal
        personal: async (params) => {
            let formData = objectToFormdata(params)
            
            return await http.post(
                `${URLs.calendars}/personal`, formData,
            )
        },
        // @Url /v1/calendars/personal/{idx}
        personalUpdate: async (params) => {
            let formData = objectToFormdata(params)
            
            return await http.post(
                `${URLs.calendars}/personal/${params.idx}`, formData,
            )
        },
        // @Url /v1/calendars/{cbidx}customer
        customer: async (params) => {
            let formData = objectToFormdata(params)
            
            return await http.post(
                `${URLs.calendars}/${params.cbidx}/customer`, formData,
            )
        },
        // @Url /v1/calendars/{cbidx}customer/{idx}
        customerUpdate: async (params) => {
            let formData = objectToFormdata(params)
            
            return await http.post(
                `${URLs.calendars}/${params.cbidx}/customer/${params.idx}`, 
                formData,
            )
        },
    },
    delete: {
        // @Url /v1/calendars/personal/{idx}
        personal: async (params) => {
            return await http.delete(
                `${URLs.calendars}/personal/${params.calendarIdx}`,
                {
                    params: params
                }
            )
        },
        // @Url /v1/calendars/{cbidx}customer/{idx}
        customer: async (params) => {
            return await http.delete(
                `${URLs.calendars}/${params.cbidx}/customer/${params.calendarIdx}`,
                {
                    params: params
                }
            )
        },
        // @Url /v1/calendars/{cbidx}/change-receiver-offer-schedule/{idx}
        changeReceiverOfferSchedule: async (params) => {
            try {
                response = await http.delete(
                    `${URLs.calendars}/${params.cbidx}/change-receiver-offer-schedule/${params.idx}`,
                    {
                        params: params
                    }
                )
                console.log('DELETE schedules/timelines/change-receiver-offer-schedule:: data', response)
                return response.data
            } catch(error) {
                console.error('DELETE schedules/timelines/change-receiver-offer-schedule: message', error)
            }
        },
        // @Url /v1/ : personal and company include others

    }
}


// WEBPACK FOOTER //
// ./src/api/calendars.js